(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('AutomaticDistributionService', AutomaticDistributionService);

  AutomaticDistributionService.$inject = ['$resource'];

  function AutomaticDistributionService ($resource) {
    return $resource(apiUrl + '/auto-dist/', {}, {
      create: { method: 'POST', params: {}, isArray: false },
      find: { method: 'GET', params: {}, isArray: false },
      update: { method: 'PUT', params: {}, isArray: false }
    });
  }
})();
